import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {CountryDropdownComponent} from '../../../../../shared/common/country-dropdown/country-dropdown.component';
import {DropdownDomainComponent} from '../../../../../shared/common/dropdown-domain/dropdown-domain.component';
import {FormsModule} from '@angular/forms';
import {InfoTextComponent} from '../../../../../shared/common/info-text/info-text.component';
import {InputText} from 'primeng/inputtext';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {DOMAIN_GENDER, DOMAIN_VALUES_GENDER} from '../../../../../../../assets/domains/domains';
import {PlayerProfile} from '../../../../model/player-profile';
import {NameHelper} from '../../../../../../helper/name.helper';
import {RestErrorHelper} from '../../../../../../helper/rest-error-helper';
import {DatePipe} from '@angular/common';
import {Button} from 'primeng/button';
import {
  PlayerProfileEditBirthdayComponent
} from './player-profile-edit-birthday/player-profile-edit-birthday.component';
import {DialogService} from 'primeng/dynamicdialog';
import {Tooltip} from 'primeng/tooltip';
import {FunctionsService} from '../../../../../../services/functions.service';

@Component({
  selector: 'app-player-profile-account-personal-data',
  standalone: true,
  imports: [
    CountryDropdownComponent,
    DropdownDomainComponent,
    FormsModule,
    InfoTextComponent,
    InputText,
    TranslatePipe,
    DatePipe,
    Button,
    Tooltip
  ],
  templateUrl: './player-profile-account-personal-data.component.html',
  styleUrl: './player-profile-account-personal-data.component.scss'
})
export class PlayerProfileAccountPersonalDataComponent
{
  private restErrorHelper = inject(RestErrorHelper);
  private translate = inject(TranslateService);
  private dialogService = inject(DialogService);
  private functionsService = inject(FunctionsService);

  protected readonly DOMAIN_VALUES_GENDER = DOMAIN_VALUES_GENDER;
  protected readonly DOMAIN_GENDER = DOMAIN_GENDER;

  @Output() onReload = new EventEmitter<any>();
  @Output() onUpdatePlayerProfileValue = new EventEmitter<any>();
  @Input() playerProfile: PlayerProfile;

  public optimizeName(value: string): string
  {
    return NameHelper.normalizeName(value);
  }

  public updatePlayerProfileValue(body: any, inputField?: any): void
  {
    this.onUpdatePlayerProfileValue.emit({body, inputField});
  }

  public changeBirthday(): void
  {
    const ref = PlayerProfileEditBirthdayComponent.openDialog(this.dialogService,
      this.playerProfile, this.translate);

    ref.onClose.subscribe((birthday: Date) =>
    {
      if (birthday)
        setTimeout(() => this.onReload.emit());
    });
  }

  public firstnameChanged(): void
  {
    this.playerProfile.firstname = NameHelper.normalizeName(this.playerProfile.firstname);
    const name = this.playerProfile.firstname;
    if (name?.length > 0)
    {
      this.functionsService.getGenderDetails(name).subscribe({
        next: data =>
        {
          console.log('Geschlecht erhalten', data);
          if (data && (data.genderCd || data.genderCd === ''))
            this.playerProfile.genderCd = data.genderCd;
        },
        error: error => console.log('Fehler beim Abruf des Geschlechts', error)
      });
    }
  }
}
